// Core
import React from 'react'

// Custom layout
import MainLayout from '../../../Layouts/Main'

//styles
import "./style.scss"

//router
import { NavLink, Outlet } from "react-router-dom";


const Mining = () => {

  const requestNavLinks = [{
    to: "newsletter",
    label: "Newsletter",
    id: "1",
  },
  {
    to : "contact-us",
    label : "Contact us",
    id : "2",
  },
  {
    to : "speak-bearing",
    label : "Speak Bearing",
    id : "3",
  },
]

  return (
    <MainLayout pageName={"Mining KG"}>
    <div className='miningContainer1'>
      <div className="miningNavBar">
        {requestNavLinks.map((option)=>(
          <div key={option.id} className="miningOptionContainer">
            <NavLink
              key={option.id}
              to={option.to}
              style={{textDecoration:"none"}}
              className={({ isActive }) =>
                isActive ? "active-miningOptionContainerNav" : "miningOptionContainerNav"
              }
            >
              {option.label}
            </NavLink>
          </div>
        ))}
      </div>
      <Outlet/>
    </div>
    </MainLayout>
  )
}

export default Mining
